import { get, isArray, template, isString, isUndefined } from 'lodash';

import { DEFAULT_LOCALE } from 'constants/locales';
import Log from 'utils/Log';
import Settings from 'utils/Settings';

class I18n {
  static get currentLocale() {
    let locale = Settings.currentLocale;

    if (!locale) {
      Log.debug(new Error(`Missing current locale. Falling back to ${DEFAULT_LOCALE}`));
      locale = DEFAULT_LOCALE;
    }

    return locale;
  }

  // This getter returns our localized copy which lives in a metafield that is placed on the window
  static get localizedCopy() {
    const { currentLocale } = I18n;

    const localizedCopy = get(window, ['ALLBIRDS', 'localizedCopy', currentLocale]);

    if (!localizedCopy) {
      Log.error(new Error(`Cannot find localizedCopy for locale "${currentLocale}"`));
    }

    return localizedCopy;
  }

  // The path argument is a dot separated string (e.g. "cart.drawer.close"). This string is used to do a key lookup in our locale map.
  // The optional context argument is used for string interpolation (see https://lodash.com/docs/4.17.15#template)
  static localize(key, context = {}) {
    if (isArray(key)) {
      Log.error(new Error(`I18n.localize() Expected a string path, got array instead: [${key}]`));
    }

    // find localization in the requested locale
    let result = get(I18n.localizedCopy, [key, 'value']);

    // notify user of missing localization
    if (isUndefined(result)) {
      const errorMessage = `Missing localization for "${key}" (${I18n.currentLocale})!`;

      Log.error(new Error(errorMessage));

      return errorMessage;
    }

    // compile the template if applicable
    if (isString(result)) {
      try {
        result = template(result)(context);
      } catch (error) {
        const errorMessage = `Missing localization context for: "${key}" (${I18n.currentLocale})!`;

        Log.error(error, errorMessage);

        return errorMessage;
      }
    }

    return result;
  }
}

export default I18n;
